import { apiClient } from './client';
import type { Enrichment } from '../types';
import { cacheEnrichment, getCachedEnrichment } from '../store/offlineStore';

export async function fetchEnrichment(wordId: string, word: string, definition: string): Promise<Enrichment> {
  const cached = await getCachedEnrichment(wordId);
  if (cached) return cached;

  try {
    // Call the AI enrich endpoint (like v1) to generate rich content
    const { data } = await apiClient.post<Enrichment>('/enrich', {
      word,
      definition,
    });
    await cacheEnrichment(wordId, data);
    return data;
  } catch {
    // Fallback to basic word endpoint if enrich fails
    try {
      const { data } = await apiClient.get<Enrichment>(`/words/${wordId}/enrichment`);
      await cacheEnrichment(wordId, data);
      return data;
    } catch {
      if (cached) return cached;
      throw new Error(`Failed to fetch enrichment for ${wordId}`);
    }
  }
}
